import type { ScheduleItem } from 'owa-graph-schema';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { isAllDayEvent, owaDate } from 'owa-datetime';
import convertFreeBusyStatusToBusyType from './convertFreeBusyStatusToBusyType';
import convertFreeBusyStatusToString from './convertFreeBusyStatusToString';
import { getAnonymousMailboxInfo } from 'owa-mailbox-info/lib/getAnonymousMailboxInfo';

export default function convertScheduleItemToCalendarEvent(
    item: ScheduleItem,
    scheduleId: string,
    timezoneToUse: string
): CalendarEvent {
    const startTz = item.startTime?.timeZone.name ?? 'UTC';
    const endTz = item.endTime?.timeZone.name ?? 'UTC';

    let start = owaDate(startTz, item.startTime?.dateTime);
    let end = owaDate(endTz, item.endTime?.dateTime);

    if (timezoneToUse !== startTz) {
        start = owaDate(timezoneToUse, start);
    }

    if (timezoneToUse !== endTz) {
        end = owaDate(timezoneToUse, end);
    }

    return {
        Start: start,
        End: end,
        Location: item.location ?? '',
        FreeBusyType: convertFreeBusyStatusToBusyType(item.status ?? 'Unknown'),
        Subject: item.subject ? item.subject : convertFreeBusyStatusToString(item.status),
        CalendarItemType: item.isException
            ? 'Exception'
            : item.isRecurring
            ? 'Occurrence'
            : 'Single',
        ItemId: {
            Id: item.id ?? '',
            mailboxInfo: getAnonymousMailboxInfo(),
        },
        ParentFolderId: {
            Id: scheduleId,
            ChangeKey: '',
            __type: 'FolderId:#Exchange',
        },
        Sensitivity: item.isPrivate ? 'Private' : 'Normal',
        IsMeeting: item.isMeeting,
        IsAllDayEvent: isAllDayEvent(start, end),
    } as CalendarEvent;
}
